<div class="td-cnt-ext" [style.top.px]="topPx">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}" id="teiasoftDialogItem">
        <div class="td-cnt-title">
            <div>
                <i *ngIf="action == 'create'" class="fal fa-plus dialog-icon"></i>
                <span *ngIf="action == 'create'" class="te-title">{{'users.createGroup' | translate}}</span>
                <i *ngIf="action == 'edit'" class="fal fa-pencil dialog-icon"></i>
                <span *ngIf="action == 'edit'" class="te-title">{{'users.editGroup' | translate}}</span>
            </div>
        </div>
        <div class="td-cnt-body">
            <div class="tm-row">
                <teiasoft-input [type]="'text'" [labelText]="'users.groupName' | translate" [isMobile]="isMobile"
                    [isRequired]="true" [value]="groupName" style="width:100%"
                    (onInput)="onInputGroupName($event)" [noMinWidth]="true" [readOnly]="false"
                    class="mr-5" [maxLength]="50"></teiasoft-input>
            </div>
            <div class="tm-row">
                <span class="span-assigned">{{'users.authorizations' | translate}}*</span>
            </div>
            <div class="mu-header">
                <div class="mu-cell mu-cell-h" ><span>{{'users.unit' | translate}}</span></div>
                <div *ngFor="let item of auths" class="mu-cell mu-cell-h" [matTooltip]="item"><span title="{{item}}">{{item}}</span></div>
            </div>
            <!-- GLOBAL -->
             <div class="mu-cnt">
                <div class="mu-row bg-global">
                    <div class="mu-cell">{{'users.global' | translate}}</div>
                    <div *ngFor="let item of auths; let i=index" class="mu-cell"><input *ngIf="isPresent('Global', i)" type="checkbox" (click)="onChkClicked('Global', item, $event, 'Global')" 
                        [checked]="isChecked('Global', item, 'Global')"></div>
                </div>
                <div *ngFor="let office of offices; let x=index" class="mu-row bg-office" [ngClass]="{'bg-office-alternate': isEven(x)}">
                    <div class="mu-cell">{{office}}</div>
                    <div *ngFor="let item of auths; let i=index" class="mu-cell"><input *ngIf="isPresent('Office', i)" type="checkbox" (click)="onChkClicked(office, item, $event, 'Office')"
                        [checked]="isChecked(office, item, 'Office')"></div>
                </div>
                <div *ngFor="let mill of mills; let x=index" class="mu-row bg-mill" [ngClass]="{'bg-mill-alternate': !isEven(x)}">
                    <div class="mu-cell">{{mill}}</div>
                    <div *ngFor="let item of auths; let i=index" class="mu-cell"><input *ngIf="isPresent('Mill', i)" type="checkbox" (click)="onChkClicked(mill, item, $event, 'Mill')"
                        [checked]="isChecked(mill, item, 'Mill')"></div>
                </div>
             </div>
           
        </div>
        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (onClick)="onSaveGroupClick()" class="mr-5" [type]="'tb-secondary'"
                [text]="'commons.save' | translate" [isMobile]="isMobile" [disabled]="isDisabledSave()">
            </teiasoft-button>
            <teiasoft-button (onClick)="onCloseModalClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>